interface HeroProps {
  scrollToContact: () => void;
}

export default function Hero({ scrollToContact }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/619ec3da7cd5afb423f156d387c87edd.jpg"
          alt="Professional Roofing"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-20">
        <div className="max-w-3xl">
          <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
            Oklahoma's Trusted Roofing Experts
          </h1>
          <p className="text-2xl md:text-3xl text-white font-medium mb-4">
            We Work Directly With Your Insurance
          </p>
          <p className="text-xl md:text-2xl text-gray-200 mb-12">
            Fast Roof Repair & Replacement
          </p>

          {/* CTA Button */}
          <div className="flex items-center gap-6 mb-8">
            <button 
              onClick={scrollToContact}
              className="group flex items-center bg-white rounded-full overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <span className="px-8 py-4 text-[#1B2838] font-semibold text-lg whitespace-nowrap">
                Get Free Estimate
              </span>
              <div className="w-14 h-14 bg-black flex items-center justify-center group-hover:bg-[#FF6B35] transition-colors">
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </div>
            </button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center gap-6 text-white">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-xl"></i>
              <a href="tel:405-397-2783" className="text-base font-medium hover:text-[#FF6B35] transition-colors cursor-pointer">
                405-397-2783
              </a>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-xl"></i>
              <span className="text-base font-medium">Lic #80007301</span>
            </div>
          </div>
        </div>

        {/* Floating Badge */}
        <div className="absolute right-6 md:right-20 top-1/2 transform -translate-y-1/2 hidden lg:block">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl w-72">
            <div className="flex items-center gap-1 mb-3">
              <i className="ri-star-fill text-yellow-500 text-lg"></i>
              <i className="ri-star-fill text-yellow-500 text-lg"></i>
              <i className="ri-star-fill text-yellow-500 text-lg"></i>
              <i className="ri-star-fill text-yellow-500 text-lg"></i>
              <i className="ri-star-fill text-yellow-500 text-lg"></i>
              <span className="ml-2 text-gray-700 font-semibold">5.0 Rating</span>
            </div>
            <h3 className="text-[#1B2838] font-bold text-lg mb-2">
              Insurance Claim Specialists
            </h3>
            <p className="text-gray-600 text-sm">
              Licensed & Insured in Oklahoma
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}